<template lang="pug">
.search-header
  .search-header__heading Refine Search
  .search-header__form
    button.search-header__submit(type="submit", @click.prevent="submitSearch") 
      i.ico-search
    input.search-header__input(
      v-model="query",
      @keydown.enter.prevent="submitSearch",
      :placeholder="settings.searchPlaceholder",
      type="text")
  .g.container-mobile
      .g__c
        .search-header__results {{ resultSummary }}
      .g__c
        .sorting-container(v-if="results.totalResultCount > 0")
          a.sorting(
            @click.stop.prevent="sortByRelevancy",
            aria-label="Sort by Relevancy",
            :class="{ sorting__active: selectedSort === 'relevancy'}"
          ) Relevancy
          span.sorting.sorting__label(
              :class="{ sorting__active: selectedSort !== 'relevancy'}"
          )
          a.sorting(
            @click.stop.prevent="sortByDate('desc')",
            aria-label="Sort by Date Descending",
            :class="{ sorting__active: selectedSort === 'desc'}"
          )
            span.sorting__desc
          a.sorting(
            @click.stop.prevent="sortByDate('asc')",
            aria-label="Sort by Date Ascending",
            :class="{ sorting__active: selectedSort === 'asc'}"
          )
            span.sorting__asc
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "SearchBox",
  props: [
    "searchPlaceholder",
    "searchButtonText",
    "showAlpha"
  ],
  computed: {
    ...mapGetters([
      'settings',
      'results',
      'searchQuery',
      'submittedSearchTerm',
      'selectedSort'
    ]),
    query: {
      get() {
        return this.searchQuery.searchTerm;
      },
      set(value) {
        this.setQuery(value);
      }
    },
    alphaFilter: {
      get() {
        return this.searchQuery.alphaFilter;
      },
      set(value) {
        if (value === this.searchQuery.alphaFilter) {
          value = "";
        }
        this.setAlphaFilter(value);
      }
    },
    resultSummary: function () {
      if(!this.submittedSearchTerm || this.submittedSearchTerm.length.trim == '') {
        return "";
      }
      
      return `${this.results.totalResultCount} results found for "${this.submittedSearchTerm}"`;
    }
  },
  methods: {
    ...mapMutations([
      'setQuery',
      'setAlphaFilter',
      'setOrderBy',
      'setSelectedSort']),
    submitAlphaFilter(letter) {
      this.alphaFilter = letter;
      this.$emit("submitalphafilter");
    },
    submitSearch() {
      this.$emit("submitsearch");

      // TODO - there's got to be a better way...
      // Updating top aon search box with search term.
      let topSearchBox = document.querySelector('#searchtxt');

      if(topSearchBox) {
        topSearchBox.value = this.searchQuery.searchTerm;
      }
    },
    sortByDate(order) {
      this.setOrderBy(`documentlastpublished ${order}`);
      this.setSelectedSort(order)
      this.$emit("submitsearch");
    },
    sortByRelevancy() {
      this.setOrderBy("");
      this.setSelectedSort("relevancy")
      this.$emit("submitsearch");
    },
  },
};
</script>
<style lang="scss" scoped>
$heading: #739abc;
$border: #d3d6d8;

body:not(.using-mouse) *:focus {
    outline: none;
}

.search-header {
    position: relative;
    display: flex;
    flex-direction: column;
    grid-area: span 1 / span 1;

    &__form {
        position: relative;
        flex: 1 1 100%;
        display: flex;
        padding: 0;
    }

    &__heading {
        line-height: 1.3;
        font-size: 1.2rem;
        font-weight: 600;
        display: inline-block;
        margin: 0 0 .5rem;
        color: $heading;

        &:only-child {
            margin: 0;
        }
    }

    &__input {
        flex: 1 1 100%;
        width: 100%;
        margin: 0;
        padding: .5rem;
        background: $white;
        border: 1px solid $border;

        &::placeholder {
            color: $black;
            font-weight: 300;
        }
    }

    &__submit {
        position: absolute;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
        background: $blue;
        color: $black;
        height: 100%;
        margin-bottom: 0;
        padding: 0 0.5rem 0 2rem;
        font-size: 2rem;
        line-height: 1;
        border: 0;
        border-left: 1px solid $border;
        font-weight: 600;
        cursor: pointer;
        background: url("../img/template-images/searchresults_submit.gif") no-repeat center;

        i {
            transform: translateY(2px);
        }
    }

    &__results {
        line-height: 1;
        font-weight: 600;
        cursor: default;
        margin-top: 1rem;
        font-size: 1rem;
    }
}

.sorting-container {
    display: flex;
    width: 100%;
    justify-content: start;
    align-items: flex-start;
    margin-top: 0;
}

.container-mobile {
  margin-bottom: 0;
}

.sorting {
    display: flex;
    justify-content: center;
    margin-left: 0;
    color: $darkGray;
    transition: 0.2s ease;
    cursor: pointer;
    color: $heading;
    font-size: 1rem;

    &::before {
        display: none;
    }

    &::after {
        font-size: 1.25rem;
    }

    &:first-child {
        margin-right: 1rem;
    }

    &__label {
        cursor: default;
    }
    
    &__asc {
        height: 1rem;
         &::after{
          content: "Date: Oldest First";
          margin-right: 1rem;
        }
    }

    &__desc {
        height: 1rem;
        &::after{
          content: "Date: Newest First";
          margin-right: 1rem;

        }
    }

    &__active {
        font-size: 1rem;
        font-weight: 700;
    }
}
</style>